import values from 'lodash/values';
import LocalityType from '../enums/locality-type';
var resolveLocalityTypeFromSlug = slug => slug && values(LocalityType).find(type => type.slugPattern && slug.match(type.slugPattern)) || null;
export default resolveLocalityTypeFromSlug;